import { acceptHMRUpdate, defineStore } from 'pinia'
import api from '@api'
import type { ByEmailContractsListParams, CarrierContractsRoutesAutocompleteParams } from '@apiTypes'

export const useCarrierContractsByEmailStore = defineStore('carrierContractsByEmail', {
  actions: {
    fetchCarrierContracts(query: ByEmailContractsListParams) {
      return api.byEmail.byEmailContractsList(query)
    },
    fetchCarrierContract(hash: string) {
      return api.byEmail.byEmailContractsRetrieve({ hash })
    },
    fetchCarrierContractPrices(hash: string) {
      return api.byEmail.carrierContractsPricesRetrieve({ hash })
    },
    routesAutocomplete(params: CarrierContractsRoutesAutocompleteParams): Promise<string[]> {
      return api.byEmail.carrierContractsRoutesAutocomplete(params).then(response => response.data.values)
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useCarrierContractsByEmailStore, import.meta.hot))
